/**
 * Enums for PackingV2 feature
 */
export var ShipmentStatus;
(function (ShipmentStatus) {
    ShipmentStatus["Input"] = "ShipInput";
    ShipmentStatus["Scheduled"] = "ShipScheduled";
    ShipmentStatus["Picked"] = "ShipPicked";
    ShipmentStatus["Packed"] = "ShipPacked";
    ShipmentStatus["Shipped"] = "ShipShipped";
    ShipmentStatus["Delivered"] = "ShipDelivered";
    ShipmentStatus["Cancelled"] = "ShipCancelled";
})(ShipmentStatus || (ShipmentStatus = {}));
export var PackingSubscreen;
(function (PackingSubscreen) {
    PackingSubscreen["ShipmentId"] = "shipmentId";
    PackingSubscreen["ScanProduct"] = "scanProduct";
    PackingSubscreen["ShipmentList"] = "shipmentList";
})(PackingSubscreen || (PackingSubscreen = {}));
export var ShipmentType;
(function (ShipmentType) {
    ShipmentType["Sales"] = "ShpTpSales";
    ShipmentType["Transfer"] = "ShpTpTransfer";
    ShipmentType["DropShip"] = "ShpTpDropShip";
    ShipmentType["Return"] = "ShpTpReturn";
})(ShipmentType || (ShipmentType = {}));
export var PackageStatus;
(function (PackageStatus) {
    PackageStatus["Open"] = "PackOpen";
    PackageStatus["Closed"] = "PackClosed";
})(PackageStatus || (PackageStatus = {}));
